// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var NotRequested = /* #__PURE__ */ (function () {
    function NotRequested() {

    };
    NotRequested.value = new NotRequested();
    return NotRequested;
})();
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Loaded = /* #__PURE__ */ (function () {
    function Loaded(value0) {
        this.value0 = value0;
    };
    Loaded.create = function (value0) {
        return new Loaded(value0);
    };
    return Loaded;
})();
var startAff = function (dictMonadFRP) {
    return function (action) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Effect_Aff.launchAff(action)))(function (fiber) {
            return Control_Monad_Cleanup.onCleanup(dictMonadFRP.MonadCleanup1())(Effect_Aff.launchAff_(Effect_Aff.killFiber(Effect_Exception.error("Cancelled"))(fiber)));
        });
    };
};
var performEvent = function (dictMonadFRP) {
    return function (event) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (output) {
            return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(function (action) {
                return Data_Functor["void"](Effect.functorEffect)(Effect_Aff.launchAff(Control_Bind.bind(Effect_Aff.bindAff)(action)(function (x) {
                    return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(output.fire(x));
                })));
            })(event))(function () {
                return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(output.event);
            });
        });
    };
};
var genericRequestState = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NotRequested.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Loading.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Loaded(x.value0.value0);
        };
        throw new Error("Failed pattern match at Specular.FRP.Async (line 34, column 1 - line 34, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NotRequested) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Loading) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Loaded) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Specular.FRP.Async (line 34, column 1 - line 34, column 66): " + [ x.constructor.name ]);
    }
};
var showRequestState = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericRequestState)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "NotRequested";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "Loading";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
            reflectSymbol: function () {
                return "Loaded";
            }
        }))))
    };
};
var functorRequestState = {
    map: function (f) {
        return function (m) {
            if (m instanceof NotRequested) {
                return NotRequested.value;
            };
            if (m instanceof Loading) {
                return Loading.value;
            };
            if (m instanceof Loaded) {
                return new Loaded(f(m.value0));
            };
            throw new Error("Failed pattern match at Specular.FRP.Async (line 35, column 1 - line 35, column 60): " + [ m.constructor.name ]);
        };
    }
};
var fromLoaded = function (v) {
    if (v instanceof Loaded) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var eqRequestState = function (dictEq) {
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof NotRequested && y instanceof NotRequested) {
                    return true;
                };
                if (x instanceof Loading && y instanceof Loading) {
                    return true;
                };
                if (x instanceof Loaded && y instanceof Loaded) {
                    return Data_Eq.eq(dictEq)(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var asyncRequestMaybe = function (dictMonadEffect) {
    return function (dictMonadFRP) {
        return function (dquery) {
            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadEffect))(function (loadStateChanged) {
                return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Effect_Ref["new"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit))))(function (cancelCurrentRef) {
                    var runAndUpdateResult = function (query) {
                        return Control_Bind.bind(Effect_Aff.bindAff)(query)(function (value) {
                            return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(loadStateChanged.fire(new Loaded(value)));
                        });
                    };
                    var update = function (m_query) {
                        return function __do() {
                            var cancelCurrent = Effect_Ref.read(cancelCurrentRef)();
                            cancelCurrent();
                            if (m_query instanceof Data_Maybe.Nothing) {
                                return Effect_Ref.write(Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit))(cancelCurrentRef)();
                            };
                            if (m_query instanceof Data_Maybe.Just) {
                                var fiber = Effect_Aff.launchAff(runAndUpdateResult(m_query.value0))();
                                return Effect_Ref.write(Effect_Aff.launchAff_(Effect_Aff.killFiber(Effect_Exception.error("Cancelled"))(fiber)))(cancelCurrentRef)();
                            };
                            throw new Error("Failed pattern match at Specular.FRP.Async (line 69, column 7 - line 74, column 84): " + [ m_query.constructor.name ]);
                        };
                    };
                    var initialStatus = function (v) {
                        if (v instanceof Data_Maybe.Just) {
                            return Loading.value;
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return NotRequested.value;
                        };
                        throw new Error("Failed pattern match at Specular.FRP.Async (line 82, column 5 - line 82, column 37): " + [ v.constructor.name ]);
                    };
                    return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Specular_FRP_Base.pull(dictMonadEffect)(Specular_FRP_Base.readBehavior(Specular_FRP_Base.current(dquery))))(function (initialValue) {
                        return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Specular_FRP_Base.holdDyn(dictMonadFRP)(initialStatus(initialValue))(Specular_FRP_Base.leftmost([ Data_Functor.map(Specular_FRP_Base.functorEvent)(initialStatus)(Specular_FRP_Base.changed(dquery)), loadStateChanged.event ])))(function (dyn) {
                            return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(update)(dquery))(function () {
                                return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(dyn);
                            });
                        });
                    });
                });
            });
        };
    };
};
var asyncRequest = function (dictMonadEffect) {
    return function (dictMonadFRP) {
        return function (dquery) {
            return asyncRequestMaybe(dictMonadEffect)(dictMonadFRP)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(dquery));
        };
    };
};
export {
    startAff,
    NotRequested,
    Loading,
    Loaded,
    fromLoaded,
    asyncRequestMaybe,
    asyncRequest,
    performEvent,
    eqRequestState,
    genericRequestState,
    functorRequestState,
    showRequestState
};
//# sourceMappingURL=index.js.map
